import { Component, OnDestroy, OnInit, ElementRef, isDevMode } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { WindowService } from './shared/window.service';
import { PageService } from './shared/page.service';
import { environment } from '../environments/environment';
import packageJson from '../../package.json';
import { CalendarioService } from './shared/calendario-service.service';
import { Gtag } from 'angular-gtag';
import { DocumentosService } from './shared/documentos/documentos.service';
import { AgrupadorDocumentos, Documento } from 'models/documento';
const hasHash = (str) => str.indexOf('#') >= 0;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnDestroy, OnInit {
  documentos: Documento[] = [];
  docsLoading = true;
  rotaAtual = null;

  rodapeExpandido = {
    estudeCeuma: false,
    mural: false,
    servicos: false,
    ppcs: false
  };

  submenuHabilitado = true;
  mobileMenuExpanded = false;
  openedMenu = false;
  isDesenvolvimento = false;

  appInfo = { version: '', ...packageJson };
  statusSubmenus = {};
  navigationSubscription: Subscription;

  notificationOptions: any = {
    timeOut: 5000,
    pauseOnHover: true,
    clickToClose: true,
    showProgressBar: false,
  };

  flagPosGraduacao: any;
  flagPosGraduacao2ViaBoleto: any;
  flagRematricula: any;
  environment = environment;
  ies: any = 'NO';
  nomeIes: any = '';

  public calendarioFilePath: string;

  constructor(
    private router: Router,
    private window: WindowService,
    private page: PageService,
    private eleRef: ElementRef,
    public gtag: Gtag,
    private calendarioService: CalendarioService,
    private documentosService: DocumentosService
  ) {
    this.isDesenvolvimento = isDevMode();
  }

  ngOnInit() {
    this.nomeIes = environment.loginContexto;
    switch (environment.loginContexto) {
      case 'CEUMA': case 'EURO':
        this.ies = 'NO';
        break;
      case 'FAMAZ':
        this.nomeIes = 'Unifamaz'
        this.ies = 'NO';
        break;
      default:
        this.ies = 'NA';
        break;
    }
    this.flagPosGraduacao = environment.flagPosGraduacao;
    this.flagPosGraduacao2ViaBoleto = environment.flagPosGraduacao2ViaBoleto;
    this.flagRematricula = environment.flagRematricula;
    const cabecalhoAncoras = this.eleRef.nativeElement.querySelectorAll('#header .menu-container .submenu-container a');
    this.navigationSubscription = this.router.events.subscribe(
      (evt) => evt instanceof NavigationEnd && this.mudarRota(evt),
    );

    for (let i = 0; i < cabecalhoAncoras.length; i++) {
      cabecalhoAncoras[i].addEventListener('click', this.onClickAncoras.bind(this));
    }

    // https://github.com/angulartics/angulartics2#include-it-in-your-application
    // this.angulartics2Facebook.startTracking();

    this.pathCalendarioAcademico();

    this.documentosService.queryPPC().then((groups: AgrupadorDocumentos[]) => {
      if (groups && groups.length > 0) {
        this.documentos = groups[0].documentos;
      }
      console.log(this.documentos)
      this.docsLoading = false;
    })
  }

  onClickAncoras() {
    this.desabilitarSubmenuTemporariamente();
    this.fecharMenuCabecalho();
  }

  mudarRota(evt) {
    this.rotaAtual = evt.url;
    if (!hasHash(evt.url)) {
      this.eleRef.nativeElement.scrollIntoView();
    }

    this.openedMenu = false;
    this.page.mobile().unlockScroll();
    this.mobileMenuExpanded = false;
    this.fecharMenu(this.rodapeExpandido);
  }

  fecharMenu(menu) {
    for (const i in menu) {
      if (menu.hasOwnProperty(i)) {
        menu[i] = false;
      }
    }
  }

  toggleRodape(caixa) {
    const status = this.rodapeExpandido[caixa];
    this.fecharMenu(this.rodapeExpandido);
    if (this.rodapeExpandido[caixa] !== undefined) {
      this.rodapeExpandido[caixa] = !status;
    }
  }

  desabilitarSubmenuTemporariamente() {
    this.submenuHabilitado = false;
    this.window.nativeWindow.setTimeout(() => {
      this.submenuHabilitado = true;
    }, 1000);
  }

  toggleMenuCabecalho() {
    this.openedMenu = !this.openedMenu;
    this.mobileMenuExpanded = !this.mobileMenuExpanded;

    (this.openedMenu) ?
      this.page.mobile().lockScroll() :
      this.page.mobile().unlockScroll();
  }

  fecharMenuCabecalho() {
    this.openedMenu = false;
    this.mobileMenuExpanded = false;
    this.fecharMenu(this.statusSubmenus);
    this.page.mobile().unlockScroll();
  }

  navegar(link) {
    this.fecharMenuCabecalho();
    this.router.navigate([link]);
  }

  navegarRematricula() {
    window.location.href = 'https://portaldoaluno.grupoceuma.com.br/FrameHTML/web/app/edu/portaleducacional/login/';
  }

  mostrarSubmenu(nomeSubmenu) {
    const statusAtual = !!this.statusSubmenus[nomeSubmenu];
    this.fecharMenu(this.statusSubmenus);
    this.statusSubmenus[nomeSubmenu] = !statusAtual;
  }

  ngOnDestroy() {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }


  vaPara(location: string): void {
    document.querySelector(`#${location}`).scrollIntoView();
  }

  pathCalendarioAcademico() {
    this.calendarioService.recuperarUrlCalendario().subscribe((result) => {
      this.calendarioFilePath = result[0]['documentos'][0]['file']['url'];
    });
  }

}
